import React from 'react';
import styles from './Table.module.css';

export default function Table({ children, className = '', striped = false, hover = false, ...rest }) {
  return (
    <div className={styles.wrapper}>
      <table className={`${styles.table} ${striped ? styles.striped : ''} ${hover ? styles.hover : ''} ${className}`} {...rest}>
        {children}
      </table>
    </div>
  );
}
